document.addEventListener('DOMContentLoaded', function () {

  const scrollTopBtn = document.querySelector('.scrolltop');
  const scrollLink = document.querySelector('.scrolltop a');

  if (scrollLink) {
    scrollLink.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  window.addEventListener('scroll', function () {
    if (!scrollTopBtn) return;

    if (window.scrollY > 200) {
      scrollTopBtn.classList.add('show');
    } else {
      scrollTopBtn.classList.remove('show');
    }
  });

});